<div class="row">
  <div class="col-12">
    <table class="table">
      <caption class="sr-only">Tabella Lista Consultazioni</caption>
      <thead>
        <tr>
          <th class="col-xs-2">Numero ruolo</th>
          <th class="col-xs-2">Anno ruolo</th>
          <th class="col-xs-3">Sezione</th>
          <th class="col-xs-3">Giudice</th>
          <th class="col-xs-2"></th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let consultation of consultationsToShow">
          <td class="col-xs-2 cell">{{consultation.numeroRuolo != null ? consultation.numeroRuolo : ""}}</td>
          <td class="col-xs-2 cell">{{consultation.annoRuolo != null ? consultation.annoRuolo : ""}}</td>
          <td class="col-xs-3 cell">{{consultation.sezione != null ? consultation.sezione : ""}}</td>
          <td class="col-xs-3 cell">{{consultation.giudice != null ? consultation.giudice : ""}}</td>

          <td class="col-xs-2">

            <div class="data_opzioni classificazione">
              <ul>
                <li class="opzioni" appDropdownFocus>
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-label="Opzioni" aria-haspopup="true"
                    aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                  <div class="dropdown-menu dropdown-table">
                    <ul>
                      <li><span class="glyphicon ml-0 glyphicon glyphicon-plus-sign"></span><a href="javascript:void(0)"
                          (click)="onCreate(consultation)">Crea Fascicolo</a></li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card-pagination">
  <app-pagination
  [resetCurrentPage]="resetCurrentPage"
  [totalItems]="consultations != undefined ? consultations.length : 0"
  (refreshEvent)="onRefresh($event)">
  </app-pagination>
</div>
